<template>
  <div class="gift-tip-dialog" v-show="visible" @click="closeDialog">
    <div class="mask" @click="closeDialog"></div>
    <div
      class="main"
      v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0)"
      @click.stop
    >
      <img class="img-title" src="../images/box_desc_title.webp" alt="" />
      <img
        class="img-close"
        src="../images/close_desc.webp"
        alt=""
        @click="closeDialog"
      />
      <div class="title">您可以在寶箱中開出以下禮物：</div>
      <div class="gift-box">
        <div class="item" v-for="(item, index) of list" :key="index">
          <div class="left">
            <img :src="item.boxImg" alt="" srcset="" />
            <span>{{ item.boxName }}</span>
          </div>
          <div
            class="right"
            :class="`bg${index + 1}`"
            v-if="item.gifts && item.gifts.length"
          >
            <div
              class="gift-item"
              v-for="giftItem of item.gifts"
              :key="giftItem.id"
            >
              <img class="gift-image" :src="giftItem.imageUrl" alt="" />
              <div class="gift-name">{{ giftItem.name }}</div>
              <div class="price-box">
                <span>{{ giftItem.paymentAmount || '' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getGiftBox } from '@/api/voice-room';
export default {
  name: 'GiftTip',
  props: {},
  data() {
    return {
      list: [],
      visible: false,
      loading: false
    };
  },
  watch: {},
  computed: {},
  created() {
    this.getGiftBox();
  },
  methods: {
    async getGiftBox() {
      try {
        this.loading = true;
        const { data } = await getGiftBox();
        this.list = data;
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    closeDialog() {
      this.visible = false;
    },
    showDialog() {
      this.visible = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.gift-tip-dialog {
  position: fixed;
  left: 0;
  top: 0;
  font-size: 14px;
  width: 520px;
  height: 100%;
  color: white;
  border-radius: 20px;
  z-index: 13;
  .mask {
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
    width: 520px;
    height: 100%;
    z-index: 11;
  }
  .main {
    width: 343px;
    height: 570px;
    background-image: url('../images/box_desc_bg.webp');
    background-size: 100% auto;
    border-radius: 20px;
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 11;
    position: absolute;
    .img-title {
      position: absolute;
      top: 8px;
      width: 308px;
      height: 38px;
      left: 50%;
      transform: translateX(-50%);
    }
    .img-close {
      position: absolute;
      top: 8px;
      right: 10px;
      width: 28px;
      height: 28px;
    }
    .title {
      text-align: center;
      color: #ffe7aa;
      font-size: 13px;
      margin-top: 60px;
    }
    .gift-box {
      height: 470px;
      overflow: auto;
      margin-top: 20px;
      @include hideScrollBar();
    }
    .item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 10px;
      padding-right: 10px;
      .left {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px;
        img {
          width: 60px;
          margin-bottom: 6px;
        }
      }
      .right {
        padding: 10px;
        border-radius: 10px;
        &.bg1 {
          background: linear-gradient(
            287.95deg,
            #351b56 0%,
            rgba(44, 15, 31, 0.2) 99.33%
          );
        }
        &.bg2 {
          background: linear-gradient(
            287.95deg,
            #56371b 0%,
            rgba(44, 31, 15, 0.2) 99.33%
          );
        }
        &.bg3 {
          background: linear-gradient(
            287.95deg,
            #414978 0%,
            rgba(48, 53, 58, 0.2) 99.33%
          );
        }
        .gift-item {
          display: inline-flex;
          flex-direction: column;
          font-size: 12px;
          align-items: center;
          color: white;
          width: 55px;
          border-radius: 10px;
          position: relative;
          margin-bottom: 20px;
        }
        .gift-name {
          margin: 6px 0;
        }
        .gift-image {
          width: 40px;
          height: auto;
        }
      }
    }
  }
}
</style>
